// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const rolePolicyManager = {
  id: "policy-manager",
  mrn: "//iam.api.mondoo.app/roles/policy-manager",
  title: "Policy Manager",
  allowedActions,
} as const;

export type RolePolicyManager = typeof rolePolicyManager;
